import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

import { IModalMessages } from '../../../types';

import { styles } from './SharePublicationLink.styles';

export type ISharePublicationLinkProps = {
  messages: IModalMessages;
  open: boolean;
  publicUrl: string;
  onClose(): void;
}

export const SharePublicationLink = ({ open, onClose, messages, publicUrl }: ISharePublicationLinkProps) => {
  if (!open) return null;

  const openTab = () => {
    window.open(publicUrl, '_blank');
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm" data-test="share-publication-link" PaperProps={{ sx: styles.dialogPaper, 'data-test': 'modal-container' }} aria-labelledby="share-publication-link-dialog-title">
      <DialogTitle id="share-publication-link-dialog-title" sx={styles.dialogTitle}>
        {messages.shareOnlinePublication}
        <IconButton aria-label="close" onClick={onClose} size="small" sx={styles.closeButton} data-test="share-publication-link-close-button">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body2" className="dialog-description">{messages.copyLinkDescription}</Typography>
        <TextField
          size="small"
          fullWidth
          label={messages.onlinePublicationURL}
          sx={styles.textField}
          defaultValue={publicUrl}
          inputProps={{ readOnly: true, 'data-test': 'publication_url', id: 'publicationURL', className: 'no-format' }}
        />
        <Box sx={styles.copyButtonWrapper}>
          <CopyToClipboard text={publicUrl}>
            <Button variant="outlined" color="secondary" size="small" data-test="copy-share-publication-link">
              {messages.copy}
            </Button>
          </CopyToClipboard>
        </Box>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="outlined" color="secondary" size="small" onClick={onClose} data-test="close-online-publication-link">
          {messages.close}
        </Button>
        <Button variant="contained" color="primary" size="small" onClick={openTab} data-test="open-in-newtab-online-publication-link">
          {messages.openInBrowser}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
